module.exports = __webpack_public_path__ + "static/map-clean-982caf79e2f2d9cdf299660bb74154b1.png";